angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "MEMBERSHIP_CANCEL": {
    "MEMBERSHIP_HEADER": "Confirm Cancellation",
    "MEMBERSHIP_BODY": "If you cancel your subscription, it will still be valid until the date you have paid up to on your last payment.<br><strong>Are you sure you would like to cancel?</strong>",
    "MEMBERSHIP_YES": "Yes",
    "MEMBERSHIP_NO": "No",
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/nls/membership.json
// module id = 84
// module chunks = 24